import { GameConfiguratorSingleton } from '@services/GameConfiguratorSingleton';
import { container } from '@config/ioc.config';
import { SERVICE_IDENTIFIER } from '@config/service-identifier';
import { Grid } from '@components/Grid';
import { Toolbar } from '@components/Toolbar';
import { GameOver } from '@components/GameOver';
import { DefenderSelectBoxes } from '@components/DefenderSelectBoxes';
var Game = /** @class */ (function () {
    function Game() {
        var _this = this;
        this.animate = function () {
            if (_this._enemiesService.isEnemyGotBase) {
                _this._isGameOver = true;
            }
            _this._context.clearRect(0, 0, _this._canvasWidth, _this._canvasHeight);
            _this._grid.draw();
            _this._defendersService.drawDefenders();
            _this._battleService.fight();
            _this._toolbar.draw();
            _this._defenderSelectBoxes.draw(_this._defendersService.selectedDefenderType);
            _this._cartridgesService.drawCartridges();
            _this._enemiesService.drawEnemies();
            _this._bonusService.drawBonuses();
            _this._gameConfigurator.frame = _this._gameConfigurator.frame + 1;
            if (!_this._isGameOver) {
                requestAnimationFrame(_this.animate);
            }
            else {
                _this._gameOver.draw();
            }
        };
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
        var context = this._gameConfigurator.context;
        if (!context) {
            throw new Error('2d context not supported or canvas already initialized');
        }
        this._canvas = this._gameConfigurator.canvas;
        this._context = this._gameConfigurator.context;
        this._canvasWidth = this._gameConfigurator.canvasWidth;
        this._canvasHeight = this._gameConfigurator.canvasHeight;
        this._isGameOver = false;
        this._cartridgesService = container.get(SERVICE_IDENTIFIER.CARTRIDGES_SERVICE);
        this._defendersService = container.get(SERVICE_IDENTIFIER.DEFENDERS_SERVICE);
        this._enemiesService = container.get(SERVICE_IDENTIFIER.ENEMIES_SERVICE);
        this._battleService = container.get(SERVICE_IDENTIFIER.BATTLE_SERVICE);
        this._bonusService = container.get(SERVICE_IDENTIFIER.BONUS_SERVICE);
        this._grid = new Grid();
        this._toolbar = new Toolbar();
        this._gameOver = new GameOver();
        this._defenderSelectBoxes = new DefenderSelectBoxes(this._defendersService.defendersData);
        this._canvas.addEventListener('click', this._defendersService.buyDefender);
        this._canvas.addEventListener('click', function () {
            return _this._defendersService.selectDefender(_this._defenderSelectBoxes.defendersSelectBoxMouses);
        });
        this.animate();
    }
    return Game;
}());
export { Game };
